export default __webpack_public_path__ + "static/media/Jason Miyares.93a35158.jpg";